<template>
  <router-view v-slot="{ Component }">
    <keep-alive :include="includeList">
      <component :is="Component" />
    </keep-alive>
  </router-view>
  <div class="menu_wkBox_back_box" />
</template>

<script setup>
  import { ref, watch, onMounted } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import WaterMark from 'l-watermark'
  import Cookies from 'js-cookie'
  import moment from 'moment'

  import { getTrackCmsConfig } from '@/api'
  import { trackView } from '@/utils'

  const cmsDataInSession = sessionStorage.getItem('recruitmentMobile') || ''

  const includeList = ref([])
  const route = useRoute()
  const router = useRouter()
  const cmsData = ref(cmsDataInSession ? JSON.parse(cmsDataInSession) : '')

  watch(router.currentRoute, () => {
    autoTrack()
  })

  watch(
    () => route,
    newValue => {
      const name = newValue.name
      if (newValue.meta.keepAlive && includeList.value.indexOf(name) === -1) {
        includeList.value.push(name)
      }
    },
    { deep: true }
  )

  onMounted(async () => {
    const empId = Cookies.get('empId')
    if (empId && location.href.includes('/rkhy/rkhy-recruitment/interviewer')) {
      WaterMark.page({
        containerEl: document.body,
        text: `${empId} ${moment().format('YYYY-MM-DD')}`,
        color: 'rgba(111,111,111,.1)',
        fontSize: 16,
        cSpace: 60,
        vSpace: 0
      })
    }
    if (cmsData.value) {
      return
    }
    try {
      const data = await getTrackCmsConfig()
      if (data?.recruitmentMobile) {
        cmsData.value = data.recruitmentMobile
        sessionStorage.setItem(
          'recruitmentMobile',
          JSON.stringify(cmsData.value)
        )
        autoTrack()
      }
    } catch (error) {
      console.log(error)
    }
  })

  const autoTrack = () => {
    if (cmsData.value) {
      const { pathname } = location
      let trackConfig = ''
      cmsData.value.every(config => {
        const configPathLen = config.pagePath.length
        if (pathname.slice(-configPathLen) === config.pagePath) {
          trackConfig = config
          return false
        } else if (pathname.includes('/rkhy-recruitment/interviewer/detail/')) {
          // 面试官详情页特殊处理
          trackConfig = {
            pageId: '121013660'
          }
          return false
        }
        return true
      })
      if (trackConfig) {
        const { pageId, appId, bizType } = trackConfig
        const empId = Cookies.get('empId')
        const bizMeta = document.getElementsByName('biz-type')[0]
        const appIdMeta = document.getElementsByName('app-id')[0]
        bizMeta && bizType !== bizMeta && (bizMeta.content = bizType)
        appIdMeta && appId !== appIdMeta && (appIdMeta.content = appId)
        trackView({
          pageLevelId: pageId,
          positionParam: {
            staffnumb: empId,
            userid: `gh-${empId}`
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  body {
    background: #e9e9e9 !important;
  }
  #app {
    min-height: 100vh;
    background: #f4f5fa;
  }
  #app * {
    box-sizing: border-box;
  }
  .ui-nowrap {
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .pf-medium {
    font-weight: 600;
  }

  .pf-simbold {
    font-weight: 700;
  }

  .y-e-ios {
    .pf-medium {
      font-weight: 500;
    }

    .pf-simbold {
      font-weight: 600;
    }
  }
  .y-e-android {
    .amend-pt {
      padding-top: 1px !important;
    }
  }
  .fullBtn {
    width: 686px;
    height: 80px;
    line-height: 82px;
    text-align: center;
    font-size: 28px;
    border-radius: 40px;
    background: #ff397e;
    color: #ffffff;
  }
  .fixBottom {
    width: 750px;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    padding-top: 48px;
    padding-bottom: calc(24px + constant(safe-area-inset-bottom));
    padding-bottom: calc(24px + env(safe-area-inset-bottom));
    background-color: #ffffff;
  }
</style>
